'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

require('../../styles/sections/theme-announcements.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('theme-announcements', {
  onLoad: function onLoad() {
    // Announcements Message slide up
    // let counter= 0;
    // console.log('announcements loaded')
    setInterval(function () {
      $('.offer').first().slideUp(function () {
        // counter +=1;
        // console.log(counter)
        $(this).appendTo($(this).parent()).css({ overflow: '', display: '' });
      });
    }, 4400);

    // Popup menu
    var DrawerNav = new Limelight('#DrawerNav', {
      bodyClass: 'active-drawer',
      hideCallback: function hideCallback(element, elements) {
        // Hide all submenus on drawer close
        drawerMenus.forEach(function (elem, index) {
          drawerMenus[index].hide();
        });

        // Scroll back to top of all menus on drawer close
        var drawerScrolls = element.element.querySelectorAll('[data-scroll-state]');
        drawerScrolls.forEach(function (elem, index) {
          drawerScrolls[index].scrollTop = 0;
        });
      }
    });

    // Popup submenus
    var childDrawers = this.container.querySelectorAll('[data-trigger="drawer-menu"]');
    window.drawerMenus = [];

    childDrawers.forEach(function (drawer, index) {
      drawerMenus[index] = new Limelight('' + drawer.dataset.target, {
        beforeShowCallback: function beforeShowCallback(element, elements) {
          drawer.closest('.theme-nav-links').classList.add('invisible');
          element.element.querySelector('[data-scroll-state]').scrollTop = 0;
        },
        beforeHideCallback: function beforeHideCallback(element, elements) {
          drawer.closest('.theme-nav-links').classList.remove('invisible');
        }
      });
    });

    // Popup currency on drawer
    var PopupCurrency = new Limelight('#PopupCurrency');

    // Announcement hide/show
    var themeAnnoucement = this.container.querySelector('[data-announcements-container]');
    var themeAnnoucementMessage = themeAnnoucement.dataset.message;
    var themeAnnoucementClose = this.container.querySelector('[data-trigger="announcement-hide"]');

    if (_jsCookie2.default.get('theme-announcement') != themeAnnoucementMessage) {
      themeAnnoucement.classList.remove('xsmall-medium--hide');
    }

    if (themeAnnoucementClose) {
      themeAnnoucementClose.addEventListener('click', function (event) {
        event.preventDefault();
        themeAnnoucement.classList.add('xsmall-medium--hide');
        _jsCookie2.default.set('theme-announcement', themeAnnoucementMessage, 30);

        var trigger = new Event('announcement:hide');
        document.dispatchEvent(trigger);
      });
    }
  }
});